import moment from 'moment/moment'

import { FORMAT_DATE } from './constants'

export default function dateParser(date) {
  if (!date) return null

  return moment(date, FORMAT_DATE).toDate()
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/dateParser.js